export const ADD_ACTIVITY = 'ADD_ACTIVITY';
export function addActivity(activity) {
  return {
    type: ADD_ACTIVITY,
    activity,
  };
}
